const EasterEgg = () => {
  return <div>Buuuuh</div>;
};

export default EasterEgg;
